class BackToTop extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';

    this.threshold = parseInt(this.dataset.threshold, 10) || 400;
    this.button = this.querySelector('[data-back-to-top-button]');
    this.isTicking = false;

    this.onScroll = this.onScroll.bind(this);

    this.abortController = new AbortController();
    const { signal } = this.abortController;

    window.addEventListener('scroll', this.onScroll, { passive: true, signal });
    this.button?.addEventListener('click', this.handleClick.bind(this), { signal });

    this.onScroll();
  }

  disconnectedCallback() {
    this.abortController?.abort();
    this.dataset.initialized = 'false';
  }

  onScroll() {
    if (this.isTicking) return;
    this.isTicking = true;

    requestAnimationFrame(() => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.classList.toggle('is-visible', scrollTop > this.threshold);
      this.isTicking = false;
    });
  }

  handleClick() {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    window.scrollTo({
      top: 0,
      behavior: prefersReducedMotion ? 'auto' : 'smooth',
    });
  }
}

if (!customElements.get('back-to-top')) {
  customElements.define('back-to-top', BackToTop);
}
